const ONES = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const TENS = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const TEENS = [
  'ده',
  'یازده',
  'دوازده',
  'سیزده',
  'چهارده',
  'پانزده',
  'شانزده',
  'هفده',
  'هجده',
  'نوزده',
];
const HUNDREDS = [
  '',
  'یکصد',
  'دویست',
  'سیصد',
  'چهارصد',
  'پانصد',
  'ششصد',
  'هفتصد',
  'هشتصد',
  'نهصد',
];
const SCALES = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون'];

const threeDigitsToWords = (value: number): string => {
  const hundred = Math.floor(value / 100);
  const ten = Math.floor((value % 100) / 10);
  const one = value % 10;
  const parts: string[] = [];

  if (hundred) parts.push(HUNDREDS[hundred]);
  if (ten === 1 && one > 0) {
    parts.push(TEENS[one]);
  } else {
    if (ten) parts.push(TENS[ten]);
    if (one) parts.push(ONES[one]);
  }

  return parts.filter(Boolean).join(' و ');
};

export const numberToPersianWords = (value: number): string => {
  const amount = Math.floor(Math.abs(value));
  if (amount === 0) return 'صفر';

  const groups: number[] = [];
  let remaining = amount;
  while (remaining > 0) {
    groups.push(remaining % 1000);
    remaining = Math.floor(remaining / 1000);
  }

  const parts: string[] = [];
  for (let index = groups.length - 1; index >= 0; index -= 1) {
    const group = groups[index];
    if (!group) continue;

    const scale = SCALES[index];
    if (!scale) {
      parts.push(threeDigitsToWords(group));
      continue;
    }

    parts.push(
      group === 1 ? `یک ${scale}` : `${threeDigitsToWords(group)} ${scale}`
    );
  }

  const words = parts.join(' و ');
  return value < 0 ? `منفی ${words}` : words;
};

export const formatRial = (value: number): string =>
  Math.round(value).toLocaleString('fa-IR');

export const formatRialTomanWords = (valueInRial: number): string => {
  const toman = Math.round(valueInRial / 10);
  return `${numberToPersianWords(toman)} تومان`;
};

export const rialMoneyStat = (valueInRial: number) => ({
  value: formatRial(valueInRial),
  sub: 'ریال',
  hint: formatRialTomanWords(valueInRial),
});
